import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Moment } from 'moment';
import momentTz from 'moment-timezone';
import { getTimezone } from '../utils/timezone.utils';

@Pipe({
  name: 'availabilityDate',
  standalone: false,
})
export class AvailabilityDatePipe implements PipeTransform {
  transform(value: string, timezone: string = getTimezone()): string {
    const date = momentTz.tz(value, timezone);
    const transformedDate = date.format('ddd Do MMMM YYYY');

    return `${transformedDate} (${date.zoneAbbr()})`;
  }
}

@Pipe({
  name: 'availabilityTime',
  standalone: false,
})
export class AvailabilityTimePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(value: string | Moment, timezone: string = getTimezone()): string {
    const format = this.locale === 'en-GB' ? 'HH:mm' : 'LT';
    return momentTz(value).tz(timezone).locale(this.locale).format(format);
  }
}
